import styled from 'styled-components'

export const SmartPromptWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`
